export class MenssagemErroHttp {
     
    private static readonly mensagens: any[] = [
        {codigo:   0, texto: 'Erro desconhecido.'},
        {codigo: 400, texto: 'Requisição inválida.'},
        {codigo: 401, texto: 'Não autorizado.'},
        {codigo: 402, texto: 'Pagamento necessário.'},
        {codigo: 403, texto: 'Proibido.'},
        {codigo: 404, texto: 'Não encontrado.'},
        {codigo: 405, texto: 'Método não permitido.'},
        {codigo: 406, texto: 'Não Aceitável.'},
        {codigo: 407, texto: 'Autenticação de proxy necessária.'},
        {codigo: 408, texto: 'Tempo de requisição esgotou.'},
        {codigo: 409, texto: 'Conflito.'},
        {codigo: 500, texto: 'Erro interno do servidor.'},
        {codigo: 501, texto: 'Não implementado.'},
        {codigo: 502, texto: 'Bad Gateway.'},
        {codigo: 503, texto: 'Serviço indisponível.'},
        {codigo: 504, texto: 'Gateway Time-Out.'},
        {codigo: 505, texto: 'Versão do HTTP não suportada.'}
      ];

    static getMensagem(codigo: number) {
       return this.mensagens.find(msg => msg.codigo === codigo).texto;  
    }
    

}



// WEBPACK FOOTER //
// ./src/app/shared/menssagem-erro-http.ts